import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Col, Form, FormGroup, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { TemplateMetadataField } from "../../../../../docuclipper/DocuclipperTypes";
import { ReduxState } from "../../../../../redux";
import {
  addMetadataField,
  deleteMetadataField,
  editMetadataField,
} from "../../../../../redux/reducers/TemplateMetadataFields";
import { options } from "./Options";

const Options: React.SFC<{
  field: { id: string; field: TemplateMetadataField };
}> = ({ field }) => {
  const [value, setValue] = React.useState("");
  const dispatch = useDispatch();
  return (
    <Form.Control
      as="select"
      value={value}
      onChange={(e) => {
        dispatch(
          editMetadataField({
            id: field.id,
            field: {
              ...field.field,
              documents: [
                {
                  regexes: [
                    {
                      regexes: [e.target.value],
                    },
                  ],
                },
              ],
            },
          })
        );
        setValue(e.target.value);
      }}
    >
      <option value=""></option>
      {options[field.field.name].map(({ value, label }) => (
        <option value={value}>{label || value}</option>
      ))}
    </Form.Control>
  );
};

type Props = {};
export const TemplateMetadataFields: React.SFC<Props> = ({}) => {
  const [fieldType, setFieldType] = React.useState("startDate");
  const dispatch = useDispatch();
  const { fields } = useSelector(
    (state: ReduxState) => state.TemplateMetadataFields
  );
  return (
    <div>
      <Row className="align-items-center">
        <Col md="10">
          <Form.Control
            as="select"
            value={fieldType}
            onChange={(e) => setFieldType(e.target.value)}
          >
            <option value="startDate">Start Date</option>
            <option value="endDate">End Date</option>
            <option value="startBalance">Start Balance</option>
            <option value="endBalance">End Balance</option>
          </Form.Control>
        </Col>
        <Col md="2">
          <Button
            variant="link"
            onClick={() =>
              dispatch(
                addMetadataField({
                  name: fieldType,
                  documents: [
                    {
                      regexes: [
                        {
                          regexes: [""],
                        },
                      ],
                    },
                  ],
                })
              )
            }
          >
            <FontAwesomeIcon icon="plus" />
          </Button>
        </Col>
      </Row>
      <div>
        {fields.map((f) => (
          <FormGroup>
            <Row className="align-items-center ml-0">
              <Form.Label>
                <strong>{f.field.name}</strong>
              </Form.Label>

              <Button
                variant="link"
                onClick={() => dispatch(deleteMetadataField(f.id))}
              >
                <FontAwesomeIcon icon="times" />
              </Button>
            </Row>

            <Options field={f} />
            <Form.Control
              value={f.field.documents[0].regexes[0].regexes[0]}
              onChange={(e) => {
                dispatch(
                  editMetadataField({
                    id: f.id,
                    field: {
                      ...f.field,
                      documents: [
                        {
                          regexes: [
                            {
                              regexes: [e.target.value],
                            },
                          ],
                        },
                      ],
                    },
                  })
                );
              }}
            ></Form.Control>
          </FormGroup>
        ))}
      </div>
    </div>
  );
};
export default TemplateMetadataFields;
